import { EOrderType } from '@aqx-core/common/api/order/model/types';

export const ORDERS_MAX_SIZE = 30;

export const BUY_ORDER_TYPES = [
  EOrderType.BUY,
  EOrderType.BUY_LIMIT,
  EOrderType.BUY_STOP,
  EOrderType.BUY_STOP_LIMIT,
  EOrderType.BUY_MARKET_TO_LIMIT
];

export const SELL_ORDER_TYPES = [
  EOrderType.SELL,
  EOrderType.SELL_LIMIT,
  EOrderType.SELL_STOP,
  EOrderType.SELL_STOP_LIMIT
];

export enum EAssetsOrderTab {
  OPEN_POSITION = 'OPEN_POSITION',
  PENDING_ORDER = 'PENDING_ORDER',
  ORDER_HISTORY = 'ORDER_HISTORY',
  POSITION_HISTORY = 'POSITION_HISTORY',
  ORDERS_AND_DEALS = 'ORDERS_AND_DEALS',
  ORDER_HISTORY_CENTROID = 'ORDER_HISTORY_CENTROID'
}

export enum EOrderExportColumn {
  COMMISSION = 'COMMISSION',
  CURRENT_PRICE = 'CURRENT_PRICE',
  ENTRY_PRICE = 'ENTRY_PRICE',
  ORDER_ID = 'ORDER_ID',
  PROFIT_LOSS = 'PROFIT_LOSS',
  STOP_LOSS = 'STOP_LOSS',
  SWAP = 'SWAP',
  SYMBOL = 'SYMBOL',
  TAKE_PROFIT = 'TAKE_PROFIT',
  TYPE = 'TYPE',
  UNITS = 'UNITS',
  VOLUME_SIZE = 'VOLUME_SIZE'
}

export enum EOrderExportDealHistoriesColumn {
  CLOSE_DATE = 'CLOSE_DATE',
  COMMISSION = 'COMMISSION',
  DEAL_TYPE = 'DEAL_TYPE',
  ENTRY_PRICE = 'ENTRY_PRICE',
  FILL_POLICY = 'FILL_POLICY',
  OPEN_DATE = 'OPEN_DATE',
  ORDER_ID = 'ORDER_ID',
  PROFIT_LOSS = 'PROFIT_LOSS',
  REMARKS = 'REMARKS',
  STATE = 'STATE',
  STOP_LOSS = 'STOP_LOSS',
  SWAP = 'SWAP',
  SYMBOL = 'SYMBOL',
  TAKE_PROFIT = 'TAKE_PROFIT',
  TYPE = 'TYPE',
  UNITS = 'UNITS',
  VOLUME_SIZE = 'VOLUME_SIZE'
}

export enum EOrderExportHistoriesColumn {
  CLOSE_DATE = 'CLOSE_DATE',
  CLOSE_PRICE = 'CLOSE_PRICE',
  COMMISSION = 'COMMISSION',
  ENTRY_PRICE = 'ENTRY_PRICE',
  OPEN_DATE = 'OPEN_DATE',
  ORDER_ID = 'ORDER_ID',
  PROFIT_LOSS = 'PROFIT_LOSS',
  REMARKS = 'REMARKS',
  STATUS = 'STATUS',
  STOP_LOSS = 'STOP_LOSS',
  SWAP = 'SWAP',
  SYMBOL = 'SYMBOL',
  TAKE_PROFIT = 'TAKE_PROFIT',
  TYPE = 'TYPE',
  UNITS = 'UNITS',
  VOLUME_SIZE = 'VOLUME_SIZE'
}

export enum EOrderExportPendingColumn {
  CURRENT_PRICE = 'CURRENT_PRICE',
  EXPIRY = 'EXPIRY',
  EXPIRY_DATE = 'EXPIRY_DATE',
  FILL_POLICY = 'FILL_POLICY',
  OPEN_TIME = 'OPEN_TIME',
  ORDER_ID = 'ORDER_ID',
  PENDING_PRICE = 'PENDING_PRICE',
  PRICE = 'PRICE',
  STOP_LOSS = 'STOP_LOSS',
  SYMBOL = 'SYMBOL',
  TAKE_PROFIT = 'TAKE_PROFIT',
  TYPE = 'TYPE',
  UNITS = 'UNITS',
  VOLUME_SIZE = 'VOLUME_SIZE'
}

export const COLUMN_ID_TO_EXPORT_COLUMN_MAP: Record<string, string> = {
  symbol: 'SYMBOL',
  orderId: 'ORDER_ID',
  positionId: 'ORDER_ID', // MT5 uses positionId
  orderType: 'TYPE',
  profit: 'PROFIT_LOSS',
  status: 'STATUS',
  openTime: 'OPEN_TIME',
  closeTime: 'CLOSE_DATE',
  lotSize: 'VOLUME_SIZE',
  units: 'UNITS',

  openPrice: 'ENTRY_PRICE',
  currentPrice: 'CURRENT_PRICE',
  closePrice: 'CLOSE_PRICE',
  priceTrigger: 'PENDING_PRICE',
  price: 'PRICE',
  takeProfit: 'TAKE_PROFIT',
  stopLoss: 'STOP_LOSS',

  // Other columns
  swap: 'SWAP',
  commission: 'COMMISSION',
  exitMethod: 'REMARKS',

  // Pending order specific
  tradeExpiry: 'EXPIRY',
  expiration: 'EXPIRY_DATE',
  fillPolicy: 'FILL_POLICY',

  // Orders & Deals specific
  state: 'STATE',
  centroidOrderState: 'STATE',
  remarks: 'REMARKS'
};
